function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3011",
  "data-name": "Group 3011",
  transform: "translate(14274 -10157)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2850",
  "data-name": "Group 2850",
  transform: "translate(8537 2663)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_139",
  "data-name": "Ellipse 139",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(-22811 7494)",
  fill: "rgba(161,164,172,0.2)"
})), /*#__PURE__*/React.createElement("path", {
  id: "forum_FILL1_wght400_GRAD0_opsz48",
  d: "M4,14.55V4.786a.778.778,0,0,1,.243-.524A.7.7,0,0,1,4.748,4h9.708a.721.721,0,0,1,.524.253.763.763,0,0,1,.243.533v6.659a.778.778,0,0,1-.243.524.711.711,0,0,1-.524.262H6.993L4.486,14.737A.276.276,0,0,1,4,14.55Zm3.76,1.422a.725.725,0,0,1-.514-.262.765.765,0,0,1-.253-.524V13.353h9.353V6.993h1.871a.7.7,0,0,1,.505.262.8.8,0,0,1,.243.542V18.273a.276.276,0,0,1-.486.187l-2.488-2.488Z",
  transform: "translate(-14269.482 10162.24)",
  fill: "#5351fb"
}));

var SvgComment = function SvgComment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment.f3ad2315.svg";
export { ForwardRef as ReactComponent };